<form [formGroup]="ondernemingFg">

    <snelstart-ui-text-form-control (change)="saveForm()"
                                    [required]=true
                                    class="me-1 custom-input-250"
                                    formControlName="naamOnderneming"
                                    id="naamOnderneming"
                                    label="Handelsnaam van de onderneming"
    >
    </snelstart-ui-text-form-control>


    <snelstart-ui-bsn-form-control (change)="saveForm()"
                                   [required]=true
                                   class="me-1 custom-input-250"
                                   formControlName="rsinOnderneming"
                                   id="rsinOnderneming"
                                   label=""
                                   label="BSN/RSIN onderneming"
    >
    </snelstart-ui-bsn-form-control>


    <snelstart-ui-select-form-control (change)="saveForm()"
                                      [options]="this.optionsRechtsvorm"
                                      [required]=true
                                      class="me-1 custom-input-250"
                                      formControlName="rechtsvorm"
                                      id="rechtsvorm"
                                      label="Rechtsvorm onderneming"
    >
    </snelstart-ui-select-form-control>


    <snelstart-ui-number-form-control (change)="saveForm()"
                                      [minValue]="1"
                                      [showAllDecimals]="false"
                                      align="right"
                                      class="me-1 custom-input-250"
                                      formControlName="goingConcernWaarde"
                                      id="goingConcernWaarde"
                                      label="Goingconcernwaarde gehele onderneming"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>


    <snelstart-ui-number-form-control (change)="saveForm()"
                                      [minValue]="1"
                                      [showAllDecimals]="false"
                                      align="right"
                                      class="me-1 custom-input-250"
                                      formControlName="liquidatieWaarde"
                                      id="liquidatieWaarde"
                                      label="Liquidatiewaarde gehele onderneming"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>


    <snelstart-ui-number-form-control (change)="saveForm()"
                                      [minValue]="1"
                                      [showAllDecimals]="true"
                                      align="right"
                                      class="me-1 custom-input-250"
                                      formControlName="aandeelInOnderneming"
                                      id="aandeelInOnderneming"
                                      label="Geschonken aandeel in de onderneming"
                                      prefix="%"
    >
    </snelstart-ui-number-form-control>


    <div formGroupName="opvolger">
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [minValue]="1"
                                          [showAllDecimals]="false"
                                          align="right"
                                          class="me-1 custom-input-250"
                                          formControlName="waardeTegenPrestatie"
                                          id="waardeTegenPrestatie"
                                          label="Betaalde koopsom voor de onderneming"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
    </div>

    <snelstart-ui-select-form-control (change)="saveForm()"
                                      [options]="this.optionsJaNee"
                                      [required]=true
                                      class="me-1 custom-input-250"
                                      formControlName="verzoekToepassenBorInIb"
                                      id="verzoekToepassenBorInIb"
                                      label="Heeft de schenker de BOR toegepast?"
    >
    </snelstart-ui-select-form-control>
    <div *ngIf="this.ondernemingFg.getRawValue().verzoekToepassenBorInIb !== null && this.ondernemingFg.getRawValue().verzoekToepassenBorInIb === false">

        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [minValue]="1"
                                          [showAllDecimals]="false"
                                          align="right"
                                          class="me-1 custom-input-250"
                                          formControlName="latenteInkomstenBelasting"
                                          id="latenteInkomstenBelasting"
                                          label="Acute belastingclaim over ond.vermogen"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
    </div>

    <div *ngIf="this.ondernemingFg.getRawValue().verzoekToepassenBorInIb !== null && this.ondernemingFg.getRawValue().verzoekToepassenBorInIb === true">

        <div *ngIf="this.ondernemingFg.get('rechtsvorm')?.value === 'BV' || this.ondernemingFg.get('rechtsvorm')?.value === 'NV'">

            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [minValue]="1"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="me-1 custom-input-250"
                                              formControlName="oorspronkelijkeVerkrijgingsprijs"
                                              id="oorspronkelijkeVerkrijgingsprijs"
                                              label="Oorspr. verkr.prijs voor alle aandelen"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
        </div>

        <div *ngIf="this.ondernemingFg.get('rechtsvorm')?.value !== 'BV' && this.ondernemingFg.get('rechtsvorm')?.value !== 'NV'">

            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [minValue]="1"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="me-1 custom-input-250"
                                              formControlName="stilleReservesInOndernemingsVermogen"
                                              id="stilleReservesInOndernemingsVermogen"
                                              label="Waarde stille reserves overgedr. ondern."
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
        </div>
    </div>

</form>
<form [formGroup]="recapitulatieFg">
    <div class="pt-3 pb-2 row col col-7 bold">
        Fiscale waarde geschonken onderneming
    </div>

    <snelstart-ui-number-form-control [minValue]="1"
                                      [showAllDecimals]="false"
                                      align="right"
                                      class="me-1 custom-input-250 custom-readonly"
                                      formControlName="waardeVanDeOnderneming"
                                      id="waardeVanDeOnderneming"
                                      label="Going concernwaarde / liquidatiewaarde"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>


    <snelstart-ui-number-form-control [minValue]="1"
                                      [showAllDecimals]="false"
                                      align="right"
                                      class="me-1 custom-input-250 custom-readonly"
                                      formControlName="koopsom"
                                      id="koopsom"
                                      label="Af: Betaalde koopsom"
                                      prefix="€ -"
    >
    </snelstart-ui-number-form-control>

    <div *ngIf="this.ondernemingFg.getRawValue().verzoekToepassenBorInIb">
        <snelstart-ui-number-form-control [minValue]="1"
                                          [showAllDecimals]="false"
                                          align="right"
                                          class="me-1 custom-input-250 custom-readonly"
                                          formControlName="latenteBelasting"
                                          id="latenteBelasting"
                                          label="Af: Toerekenbare latente belastingen"
                                          prefix="€ -"
        >
        </snelstart-ui-number-form-control>
    </div>
    <div *ngIf="!this.ondernemingFg.getRawValue().verzoekToepassenBorInIb">
        <snelstart-ui-number-form-control [minValue]="1"
                                          [showAllDecimals]="false"
                                          align="right"
                                          class="me-1 custom-input-250 custom-readonly"
                                          formControlName="latenteBelasting"
                                          id="latenteBelasting"
                                          label="Af: Belastingschuld"
                                          prefix="€ -"
        >
        </snelstart-ui-number-form-control>
    </div>


    <snelstart-ui-number-form-control [minValue]="1"
                                      [showAllDecimals]="false"
                                      align="right"
                                      class="me-1 custom-input-250 custom-readonly"
                                      formControlName="belasteWaardeVanDeOnderneming"
                                      id="belasteWaardeVanDeOnderneming"
                                      label="Belaste waarde van de onderneming"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>

</form>


